import { ListingTypes } from "../../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Criteria/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.ListingTypes */
export { ListingTypes };
/** CoStar.Api.AptsSearch.Apartments.Criteria.SeniorHousingTypes */
export var SeniorHousingTypes;
(function (SeniorHousingTypes) {
    SeniorHousingTypes[SeniorHousingTypes["None"] = 0] = "None";
    SeniorHousingTypes[SeniorHousingTypes["ActiveAdult"] = 1] = "ActiveAdult";
    SeniorHousingTypes[SeniorHousingTypes["Independentliving"] = 2] = "Independentliving";
    SeniorHousingTypes[SeniorHousingTypes["SeniorHousing"] = 4] = "SeniorHousing";
})(SeniorHousingTypes || (SeniorHousingTypes = {}));
import { StudentHousingTypes } from "../../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Criteria/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.StudentHousingTypes */
export { StudentHousingTypes };
import { StudentHousingPricingTypes } from "../../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Criteria/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.StudentHousingPricingTypes */
export { StudentHousingPricingTypes };
import { StudentHousingAmenityTypes } from "../../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Criteria/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.StudentHousingAmenityTypes */
export { StudentHousingAmenityTypes };
/** CoStar.Api.AptsSearch.Apartments.Criteria.AmenityTypes */
export var AmenityTypes;
(function (AmenityTypes) {
    AmenityTypes[AmenityTypes["None"] = 0] = "None";
    AmenityTypes[AmenityTypes["SmokeFree"] = 1] = "SmokeFree";
    AmenityTypes[AmenityTypes["WasherDryer"] = 2] = "WasherDryer";
    AmenityTypes[AmenityTypes["Dishwasher"] = 4] = "Dishwasher";
    AmenityTypes[AmenityTypes["Heating"] = 8] = "Heating";
    AmenityTypes[AmenityTypes["AirConditioning"] = 16] = "AirConditioning";
    AmenityTypes[AmenityTypes["Balcony"] = 32] = "Balcony";
    AmenityTypes[AmenityTypes["Fireplace"] = 64] = "Fireplace";
    AmenityTypes[AmenityTypes["Furnished"] = 128] = "Furnished";
    AmenityTypes[AmenityTypes["Gym"] = 256] = "Gym";
    AmenityTypes[AmenityTypes["Pool"] = 512] = "Pool";
    AmenityTypes[AmenityTypes["TennisCourt"] = 1024] = "TennisCourt";
    AmenityTypes[AmenityTypes["RoofTerrace"] = 2048] = "RoofTerrace";
    AmenityTypes[AmenityTypes["BasketballCourt"] = 4096] = "BasketballCourt";
    AmenityTypes[AmenityTypes["Playground"] = 8192] = "Playground";
    /** @deprecated Please use PricingTools.RentSpecial instead. */
    AmenityTypes[AmenityTypes["RentSpecials"] = 16384] = "RentSpecials";
    AmenityTypes[AmenityTypes["GarageParking"] = 32768] = "GarageParking";
    AmenityTypes[AmenityTypes["WheelchairAccess"] = 65536] = "WheelchairAccess";
    AmenityTypes[AmenityTypes["Parking"] = 131072] = "Parking";
    AmenityTypes[AmenityTypes["HighSpeedInternet"] = 262144] = "HighSpeedInternet";
    AmenityTypes[AmenityTypes["Elevator"] = 524288] = "Elevator";
    AmenityTypes[AmenityTypes["WasherDryerHookup"] = 1048576] = "WasherDryerHookup";
    AmenityTypes[AmenityTypes["LaundryFacilities"] = 2097152] = "LaundryFacilities";
    AmenityTypes[AmenityTypes["Gated"] = 4194304] = "Gated";
    AmenityTypes[AmenityTypes["UtilitiesIncluded"] = 8388608] = "UtilitiesIncluded";
    AmenityTypes[AmenityTypes["Lofts"] = 16777216] = "Lofts";
    AmenityTypes[AmenityTypes["Basement"] = 33554432] = "Basement";
    AmenityTypes[AmenityTypes["BusinessCenter"] = 67108864] = "BusinessCenter";
    AmenityTypes[AmenityTypes["Clubhouse"] = 134217728] = "Clubhouse";
    AmenityTypes[AmenityTypes["Concierge"] = 268435456] = "Concierge";
    AmenityTypes[AmenityTypes["ControlledAccess"] = 536870912] = "ControlledAccess";
    AmenityTypes[AmenityTypes["Den"] = 1073741824] = "Den";
    AmenityTypes[AmenityTypes["Doorman"] = 2147483648] = "Doorman";
    AmenityTypes[AmenityTypes["HardwoodFloors"] = 4294967296] = "HardwoodFloors";
    AmenityTypes[AmenityTypes["Office"] = 8589934592] = "Office";
    AmenityTypes[AmenityTypes["Patio"] = 17179869184] = "Patio";
    AmenityTypes[AmenityTypes["WalkInClosets"] = 34359738368] = "WalkInClosets";
    AmenityTypes[AmenityTypes["Yard"] = 68719476736] = "Yard";
    AmenityTypes[AmenityTypes["CarChargingStation"] = 137438953472] = "CarChargingStation";
    AmenityTypes[AmenityTypes["Refrigerator"] = 274877906944] = "Refrigerator";
    AmenityTypes[AmenityTypes["Kitchen"] = 549755813888] = "Kitchen";
    AmenityTypes[AmenityTypes["Range"] = 1099511627776] = "Range";
    AmenityTypes[AmenityTypes["MaintenanceOnSite"] = 2199023255552] = "MaintenanceOnSite";
    AmenityTypes[AmenityTypes["GarbageDisposal"] = 4398046511104] = "GarbageDisposal";
    AmenityTypes[AmenityTypes["Microwave"] = 8796093022208] = "Microwave";
    AmenityTypes[AmenityTypes["CableReady"] = 17592186044416] = "CableReady";
    AmenityTypes[AmenityTypes["StorageSpace"] = 35184372088832] = "StorageSpace";
    AmenityTypes[AmenityTypes["Oven"] = 70368744177664] = "Oven";
    AmenityTypes[AmenityTypes["TubShower"] = 140737488355328] = "TubShower";
    AmenityTypes[AmenityTypes["Courtyard"] = 281474976710656] = "Courtyard";
    AmenityTypes[AmenityTypes["StainlessSteelApplicances"] = 562949953421312] = "StainlessSteelApplicances";
    AmenityTypes[AmenityTypes["Grill"] = 1125899906842624] = "Grill";
    AmenityTypes[AmenityTypes["GraniteCountertop"] = 2251799813685248] = "GraniteCountertop";
    AmenityTypes[AmenityTypes["Carpet"] = 4503599627370496] = "Carpet";
    AmenityTypes[AmenityTypes["HighCeilings"] = 9007199254740992] = "HighCeilings";
    AmenityTypes[AmenityTypes["CeilingFans"] = 18014398509481984] = "CeilingFans";
    AmenityTypes[AmenityTypes["DogPark"] = 36028797018963970] = "DogPark";
    AmenityTypes[AmenityTypes["PackageService"] = 72057594037927940] = "PackageService";
    AmenityTypes[AmenityTypes["Freezer"] = 144115188075855870] = "Freezer";
    AmenityTypes[AmenityTypes["IndividualLockingBedrooms"] = 288230376151711740] = "IndividualLockingBedrooms";
    AmenityTypes[AmenityTypes["OnlineServices"] = 576460752303423500] = "OnlineServices";
    AmenityTypes[AmenityTypes["PrivateBathroom"] = 1152921504606847000] = "PrivateBathroom";
    AmenityTypes[AmenityTypes["RoommateMatching"] = 2305843009213694000] = "RoommateMatching";
    AmenityTypes[AmenityTypes["ShuttleToCampus"] = 4611686018427388000] = "ShuttleToCampus";
    AmenityTypes[AmenityTypes["WalkUp"] = 9223372036854776000] = "WalkUp";
})(AmenityTypes || (AmenityTypes = {}));
/** CoStar.Api.AptsSearch.Apartments.Criteria.AmenityType */
export var AmenityType;
(function (AmenityType) {
    AmenityType[AmenityType["AirConditioning"] = 2] = "AirConditioning";
    AmenityType[AmenityType["Balcony"] = 7] = "Balcony";
    AmenityType[AmenityType["BusinessCenter"] = 13] = "BusinessCenter";
    AmenityType[AmenityType["CableReady"] = 15] = "CableReady";
    AmenityType[AmenityType["ControlledAccess"] = 16] = "ControlledAccess";
    AmenityType[AmenityType["Clubhouse"] = 17] = "Clubhouse";
    AmenityType[AmenityType["Concierge"] = 21] = "Concierge";
    AmenityType[AmenityType["Courtyard"] = 26] = "Courtyard";
    AmenityType[AmenityType["Dishwasher"] = 29] = "Dishwasher";
    AmenityType[AmenityType["GarbageDisposal"] = 30] = "GarbageDisposal";
    AmenityType[AmenityType["Fireplace"] = 35] = "Fireplace";
    AmenityType[AmenityType["Gym"] = 36] = "Gym";
    AmenityType[AmenityType["LaundryFacilities"] = 48] = "LaundryFacilities";
    AmenityType[AmenityType["Microwave"] = 52] = "Microwave";
    AmenityType[AmenityType["Playground"] = 56] = "Playground";
    AmenityType[AmenityType["Pool"] = 58] = "Pool";
    AmenityType[AmenityType["StorageSpace"] = 74] = "StorageSpace";
    AmenityType[AmenityType["TennisCourt"] = 77] = "TennisCourt";
    AmenityType[AmenityType["WasherDryer"] = 81] = "WasherDryer";
    AmenityType[AmenityType["WasherDryerHookup"] = 82] = "WasherDryerHookup";
    AmenityType[AmenityType["Gated"] = 112] = "Gated";
    AmenityType[AmenityType["Heating"] = 116] = "Heating";
    AmenityType[AmenityType["BasketballCourt"] = 117] = "BasketballCourt";
    AmenityType[AmenityType["Doorman"] = 126] = "Doorman";
    AmenityType[AmenityType["FurnishedUnits"] = 129] = "FurnishedUnits";
    AmenityType[AmenityType["Grill"] = 131] = "Grill";
    AmenityType[AmenityType["PackageService"] = 144] = "PackageService";
    AmenityType[AmenityType["CeilingFans"] = 163] = "CeilingFans";
    AmenityType[AmenityType["Kitchen"] = 170] = "Kitchen";
    AmenityType[AmenityType["GraniteCountertop"] = 171] = "GraniteCountertop";
    AmenityType[AmenityType["HardwoodFloors"] = 172] = "HardwoodFloors";
    AmenityType[AmenityType["HighSpeedInternet"] = 174] = "HighSpeedInternet";
    AmenityType[AmenityType["Refrigerator"] = 178] = "Refrigerator";
    AmenityType[AmenityType["Oven"] = 180] = "Oven";
    AmenityType[AmenityType["StainlessSteelApplicances"] = 182] = "StainlessSteelApplicances";
    AmenityType[AmenityType["Range"] = 183] = "Range";
    AmenityType[AmenityType["TubShower"] = 184] = "TubShower";
    AmenityType[AmenityType["WalkInClosets"] = 188] = "WalkInClosets";
    AmenityType[AmenityType["Carpet"] = 190] = "Carpet";
    AmenityType[AmenityType["Yard"] = 192] = "Yard";
    AmenityType[AmenityType["RoofTerrace"] = 206] = "RoofTerrace";
    AmenityType[AmenityType["CarChargingStation"] = 213] = "CarChargingStation";
    AmenityType[AmenityType["Elevator"] = 219] = "Elevator";
    AmenityType[AmenityType["MaintenanceOnSite"] = 233] = "MaintenanceOnSite";
    AmenityType[AmenityType["OnlineServices"] = 237] = "OnlineServices";
    AmenityType[AmenityType["Basement"] = 254] = "Basement";
    AmenityType[AmenityType["Den"] = 259] = "Den";
    AmenityType[AmenityType["Freezer"] = 265] = "Freezer";
    AmenityType[AmenityType["Furnished"] = 266] = "Furnished";
    AmenityType[AmenityType["Lofts"] = 276] = "Lofts";
    AmenityType[AmenityType["Office"] = 279] = "Office";
    AmenityType[AmenityType["Patio"] = 281] = "Patio";
    AmenityType[AmenityType["SmokeFree"] = 285] = "SmokeFree";
    AmenityType[AmenityType["WheelchairAccess"] = 291] = "WheelchairAccess";
    AmenityType[AmenityType["HighCeilings"] = 310] = "HighCeilings";
    AmenityType[AmenityType["IndividualLockingBedrooms"] = 359] = "IndividualLockingBedrooms";
    AmenityType[AmenityType["PrivateBathroom"] = 363] = "PrivateBathroom";
    AmenityType[AmenityType["RoommateMatching"] = 365] = "RoommateMatching";
    AmenityType[AmenityType["ShuttleToCampus"] = 366] = "ShuttleToCampus";
    AmenityType[AmenityType["StudyLounge"] = 367] = "StudyLounge";
    AmenityType[AmenityType["DogPark"] = 471] = "DogPark";
    AmenityType[AmenityType["EVCharging"] = 472] = "EVCharging";
    AmenityType[AmenityType["WalkUp"] = 534] = "WalkUp";
    AmenityType[AmenityType["Parking"] = -3] = "Parking";
    AmenityType[AmenityType["GarageParking"] = -2] = "GarageParking";
    AmenityType[AmenityType["UtilitiesIncluded"] = -1] = "UtilitiesIncluded";
})(AmenityType || (AmenityType = {}));
import { BuildingRatings } from "../../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Criteria/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.BuildingRatings */
export { BuildingRatings };
/** CoStar.Api.AptsSearch.Apartments.Criteria.GreenCertifications */
export var GreenCertifications;
(function (GreenCertifications) {
    GreenCertifications[GreenCertifications["None"] = 0] = "None";
    GreenCertifications[GreenCertifications["Leed"] = 1] = "Leed";
    GreenCertifications[GreenCertifications["EnergyStar"] = 2] = "EnergyStar";
})(GreenCertifications || (GreenCertifications = {}));
import { PetFriendlyPolicies } from "../../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Criteria/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.PetFriendlyPolicies */
export { PetFriendlyPolicies };
/** CoStar.Api.AptsSearch.Apartments.Criteria.HousingSpecialties */
export var HousingSpecialties;
(function (HousingSpecialties) {
    HousingSpecialties[HousingSpecialties["None"] = 0] = "None";
    HousingSpecialties[HousingSpecialties["Senior"] = 1] = "Senior";
    HousingSpecialties[HousingSpecialties["Military"] = 2] = "Military";
    HousingSpecialties[HousingSpecialties["Student"] = 4] = "Student";
    HousingSpecialties[HousingSpecialties["Corporate"] = 8] = "Corporate";
    HousingSpecialties[HousingSpecialties["ShortTerm"] = 16] = "ShortTerm";
    HousingSpecialties[HousingSpecialties["IncomeRestricted"] = 32] = "IncomeRestricted";
    /** @deprecated Use StudentHousingTypes.OnCampusHousing. */
    HousingSpecialties[HousingSpecialties["OnCampusHousing"] = 64] = "OnCampusHousing";
    /** @deprecated Use StudentHousingTypes.OffCampusHousing. */
    HousingSpecialties[HousingSpecialties["OffCampusHousing"] = 128] = "OffCampusHousing";
})(HousingSpecialties || (HousingSpecialties = {}));
import { PricingTools } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.PricingTools */
export { PricingTools };
/** CoStar.Api.AptsSearch.Apartments.Criteria.SearchOptions */
export var SearchOptions;
(function (SearchOptions) {
    SearchOptions[SearchOptions["None"] = 0] = "None";
    SearchOptions[SearchOptions["IncludeTier2"] = 1] = "IncludeTier2";
    SearchOptions[SearchOptions["IsNew"] = 2] = "IsNew";
    SearchOptions[SearchOptions["AllowSupplementalShortTermListings"] = 4] = "AllowSupplementalShortTermListings";
    SearchOptions[SearchOptions["IsForRentByOwner"] = 8] = "IsForRentByOwner";
    SearchOptions[SearchOptions["IsDupTriQuadPlex"] = 16] = "IsDupTriQuadPlex";
})(SearchOptions || (SearchOptions = {}));
/** CoStar.Api.AptsSearch.Apartments.Criteria.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["Default"] = 0] = "Default";
    SortType[SortType["LowestRent"] = 1] = "LowestRent";
    SortType[SortType["Newest"] = 2] = "Newest";
    SortType[SortType["HighestRent"] = 3] = "HighestRent";
    SortType[SortType["HasVideo"] = 4] = "HasVideo";
    SortType[SortType["Has3DTour"] = 5] = "Has3DTour";
    SortType[SortType["RecentlyUpdated"] = 6] = "RecentlyUpdated";
    SortType[SortType["DealSort"] = 7] = "DealSort";
})(SortType || (SortType = {}));
/** CoStar.Api.AptsSearch.Apartments.Criteria.DateMeasure */
export var DateMeasure;
(function (DateMeasure) {
    DateMeasure[DateMeasure["Unknown"] = 0] = "Unknown";
    DateMeasure[DateMeasure["Days"] = 1] = "Days";
})(DateMeasure || (DateMeasure = {}));
import { ImageSize } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/index.js";
/** CoStar.Api.AptsSearch.Apartments.Criteria.ImageSize */
export { ImageSize };
/** CoStar.Api.AptsSearch.Apartments.Criteria.RentTrendDistributionGeographyTypes */
export var RentTrendDistributionGeographyTypes;
(function (RentTrendDistributionGeographyTypes) {
    RentTrendDistributionGeographyTypes[RentTrendDistributionGeographyTypes["City"] = 6] = "City";
})(RentTrendDistributionGeographyTypes || (RentTrendDistributionGeographyTypes = {}));
/** CoStar.Api.AptsSearch.Apartments.Criteria.Country */
export var Country;
(function (Country) {
    Country[Country["USA"] = 1] = "USA";
    Country[Country["CAN"] = 2] = "CAN";
})(Country || (Country = {}));
